import { render, staticRenderFns } from "./research.vue?vue&type=template&id=c7de6ef8&scoped=true"
import script from "./research.vue?vue&type=script&lang=js"
export * from "./research.vue?vue&type=script&lang=js"
import style0 from "./research.vue?vue&type=style&index=0&id=c7de6ef8&prod&lang=less&scoped=true"
import style1 from "./research.vue?vue&type=style&index=1&id=c7de6ef8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7de6ef8",
  null
  
)

export default component.exports